module.exports = __webpack_public_path__ + "static/media/mercurio_error_404.e867aeb0.svg";